import { Link } from "react-router-dom";
import { useState } from "react";
import AuthNavButton from "./AuthNavButton";

const AppHeader: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <header className="fixed top-0 left-0 right-0 bg-[#F3F6F1]/95 backdrop-blur-md border-b border-[#E5E9E2] z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex items-center">
                        <Link to="/" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors" onClick={closeMenu}>
                            <img
                                src="/assets/logo.png"
                                alt="Constela Brasil"
                                className="h-10 w-auto"
                            />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-8">
                        <Link to="/" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors">
                            Home
                        </Link>
                        <Link to="/terapeutas" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors">
                            Terapeutas
                        </Link>
                        <Link to="/quero-participar" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors">
                            Quero participar
                        </Link>
                        <Link to="/planos" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors">
                            Planos
                        </Link>
                        <Link to="/contato" className="text-[#3A5859] hover:text-[#A56096] font-medium transition-colors">
                            Contato
                        </Link>
                        <AuthNavButton />
                    </nav>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center space-x-4">
                        <AuthNavButton isMobile={true} />
                        <button
                            onClick={toggleMenu}
                            className="text-[#3A5859] hover:text-[#A56096] focus:outline-none"
                            aria-label="Toggle menu"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation Menu */}
                {isMenuOpen && (
                    <div className="md:hidden bg-[#F3F6F1]/95 backdrop-blur-md border-t border-[#E5E9E2]">
                        <nav className="px-4 py-4 space-y-4">
                            <Link
                                to="/"
                                className="block text-[#3A5859] hover:text-[#A56096] font-medium transition-colors"
                                onClick={closeMenu}
                            >
                                Home
                            </Link>
                            <Link
                                to="/terapeutas"
                                className="block text-[#3A5859] hover:text-[#A56096] font-medium transition-colors"
                                onClick={closeMenu}
                            >
                                Terapeutas
                            </Link>
                            <Link
                                to="/quero-participar"
                                className="block text-[#3A5859] hover:text-[#A56096] font-medium transition-colors"
                                onClick={closeMenu}
                            >
                                Quero participar
                            </Link>
                            <Link
                                to="/planos"
                                className="block text-[#3A5859] hover:text-[#A56096] font-medium transition-colors"
                                onClick={closeMenu}
                            >
                                Planos
                            </Link>
                            <Link
                                to="/contato"
                                className="block text-[#3A5859] hover:text-[#A56096] font-medium transition-colors"
                                onClick={closeMenu}
                            >
                                Contato
                            </Link>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
}

export default AppHeader;